module.exports = __webpack_public_path__ + "img/k3-3.bb60e026.png";